import { Layout ,Button} from "antd";
import {  Link } from "react-router-dom";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import ContingentExpense from "../../Components/ExpenseManagement/ContingentExpense";
import CorporateExpense from "../../Components/ExpenseManagement/CorporateExpense";
import Cookies from "js-cookie";
import { routes } from "../../Utils/Utils";

const CorporateExpenseManagement = () => {
    const tenantName = Cookies.get("tenant_name");
    const { Header, Content } = Layout;
    return (
        <div className="timecards-container">
            <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                <SideNavBar />
                <Layout className="timecards-sub-layout-container">
                    <Header className="timecards-header">
                        <Navbar />
                    </Header>
                    <Content style={{overflowY:"hidden"}}>
                       <div style={{overflowY:"hidden"}}>
                       <div className="expensepages">

                    <Link to={`/${tenantName}/contingentexpensemanagement`}><Button className="page-button">ContingentExpenseManagement</Button></Link>
                    <Link to={`/${tenantName}/corporateexpensemanagement`}><Button className="currentpreview-button">CorporateExpenseManagement</Button></Link>
                    <Link to={`/${tenantName}/glcodes`}><Button className="page-button">GL Code</Button></Link>
                    </div>
                        <CorporateExpense/>
                       </div>
                    </Content>
                </Layout>
            </Layout>
        </div>
    )
}

export default CorporateExpenseManagement;